module.exports = __webpack_public_path__ + "c4a4052d6f61dcecdfa5c9f78402db98.svg";